// @flow

import * as React from 'react';

import { useTranslator } from '@gandi/translate';
import { Base, Button } from '@gandi/ui';

import Icon from './Icon';

import styles from './OperationAlreadyExistsErrorRow.scss';

type Props = {
  ordersListUrl: string,
};

export default function OperationAlreadyExistsErrorRow({
  ordersListUrl,
}: Props): React.MixedElement {
  const { __ } = useTranslator();

  return (
    <Base flex flexCol gap="xsmall">
      <Base flex flexAlignItemsCenter gap="xsmall">
        <Icon name="dangerWire" theme="danger" title={__('danger')} />
        {__(
          'A similar operation is already in progress or waiting for payment.',
        )}
      </Base>
      <Base>
        {__(
          'Please check your orders list and cancel ' +
            'the previous operation if it exists, then try again.',
        )}
      </Base>
      <Button small kind="outline" to={ordersListUrl} className={styles.button}>
        {__('View orders list')}
      </Button>
    </Base>
  );
}
